/** The calendar, private tracked dates, reminders, and the "+" menu (docs 13, 18). */
export const calendarCopy = {
  calendar: {
    title: 'Calendar',
    onDay: (n: number) => (n === 1 ? '1 thing on' : `${n} things on`),
    empty: {
      title: 'Your calendar’s looking a little lonely.',
      body: 'Add your family’s birthdays, or track a date just for you.',
      action: 'Add a date',
    },
  },
  trackedDate: {
    newTitle: 'Track a date',
    editTitle: 'Edit date',
    subhead: 'Just for you. Nobody else in your family sees this.',
    labelLabel: 'What is it?',
    labelPlaceholder: 'Aunt Carol’s birthday',
    kindLabel: 'Kind',
    dateLabel: 'When?',
    personLabel: 'About someone in your family?',
    personNone: 'Nobody in particular',
    notesLabel: 'Notes',
    remindersLabel: 'Remind me',
    remindersOff: 'No reminders',
    submit: 'Save date',
    saved: 'Saved. We’ll remind you. 🔒',
    delete: 'Delete date',
    deleteConfirm: {
      title: 'Delete this date?',
      body: 'Your reminders for it stop too.',
      confirm: 'Delete date',
    },
  },
  reminders: {
    title: 'Reminders',
    familyBirthdays: 'Remind me about family birthdays',
    familyBirthdaysHint: 'Applies to everyone in all of your families, except you.',
    timing: 'When?',
    timezone: 'Your timezone',
    myDates: 'Your private dates',
    addDate: 'Add a date',
    saved: 'Saved.',
    offsets: {
      0: 'Day of',
      1: '1 day before',
      3: '3 days before',
      7: '1 week before',
      14: '2 weeks before',
      30: '1 month before',
    } as Record<number, string>,
  },
  fab: {
    label: 'Add',
    /** Desktop has no Fab: the sidebar's button opens the same menu. */
    newButton: 'New',
    newGiftList: 'New gift list',
    addToWishlist: 'Add to my wishlist',
    saveIdea: 'Save a gift idea',
    trackDate: 'Track a date',
    addPerson: 'Add someone',
  },
} as const;
